import React, { useEffect, useState } from 'react';
import axios from 'axios';
import baseURL from './baseUrl';

const Articles = () => {
  const [articles, setArticles] = useState([]);
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchArticles = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/api/articles`);
      setArticles(response.data || []);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load articles');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Article name is required');
      return;
    }
    try {
      await axios.post(`${baseURL}/api/articles`, { name: trimmed });
      setName('');
      setMessage('Article created successfully');
      setError('');
      fetchArticles();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create article');
      setMessage('');
    }
  };

  const handleDelete = async (id) => {
    const ok = window.confirm('Delete this article?');
    if (!ok) return;
    try {
      await axios.delete(`${baseURL}/api/articles/${id}`);
      setMessage('Article deleted');
      fetchArticles();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete article');
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3">Create Article</h2>

      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleCreate} className="card card-body mb-4 shadow-sm">
        <div className="row g-2 align-items-end">
          <div className="col-md-8">
            <label className="form-label">Article Name</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Chain, Ring, Coin"
              required
            />
          </div>
          <div className="col-md-4">
            <button type="submit" className="btn btn-primary w-100">
              Create Article
            </button>
          </div>
        </div>
      </form>

      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title">Articles</h5>
          {loading ? (
            <p>Loading...</p>
          ) : articles.length === 0 ? (
            <p className="text-muted mb-0">No articles created yet.</p>
          ) : (
            <table className="table table-bordered table-sm mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th style={{ width: 120 }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {articles.map((article) => (
                  <tr key={article._id}>
                    <td>{article.name}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleDelete(article._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Articles;
